export const campagnaSelector = (state) => state.persistentStore.campagna;

export const campagneAttiveScreeningSelector = (state) => state.persistentStore.campagneAttiveScreening